import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BlendEvent, FileItem } from 'src/app/shared/models';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { BatchRestoreService } from '../services/batch-restore.service';
import { IBatchActionView } from 'src/sync';
import { BlendService } from 'src/app/shared/services/blend.service';

@Component({
  selector: 'app-dialog-restore',
  templateUrl: './dialog-restore.component.html',
  styleUrls: ['./dialog-restore.component.scss']
})
export class DialogRestoreComponent implements OnInit{
  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() showDialog!: boolean;
  @Input() public selectedFiles: FileItem[];
  public subTitle: string;
  public batchView: IBatchActionView;
  public restoreItems: FileItem[] = [];
  constructor(
    private snackbarService: SnackbarService,
    private batchRestoreService: BatchRestoreService,
    private blendService: BlendService,
    ) { }
  ngOnInit(): void {
    this.batchRestoreService.init();
    this.restoreItems = [...this.selectedFiles];
    this.batchView = this.batchRestoreService.view;
    if (this.restoreItems.length > 1) {
      this.subTitle = this.restoreItems.length + ' items';
    } else {
      this.subTitle = this.restoreItems[0].name
    }
  }
  restoreFiles = async () => {
    const sync_id_array: number[] = [];
    for (let i = this.restoreItems.length - 1; i >= 0; i--) {
      sync_id_array.push(this.restoreItems[i].sync_id);
      const itemType = this.restoreItems[i].type === 'dir' ? 'folder' : 'file';
      this.blendService.track(BlendEvent.RESTORE, {type: itemType, mime_type: this.restoreItems[i].mime_type, size: this.restoreItems[i].size});  

    }
    const subject = this.batchRestoreService.execute(sync_id_array);
    subject.complete = () => {
      this.snackbarService.showMessage(
        'success', 
        `${this.restoreItems.length > 1 
          ? `${this.restoreItems.length} items have been successfully restored.` 
          : `'${this.restoreItems[0].name}' has been successfully restored.`}`
      );
      this.closeDialog();
      subject.unsubscribe();
    }
    subject.error = () => {
      this.batchView.spinner = 0;
      this.snackbarService.showMessage('critical', `Couldn't complete action. Try again.`);
      this.closeDialog();
    }
  }
  closeDialog = () => {
    this.showDialog = false;
    setTimeout(() => {
      this.showDialogChange.next(false);
    }, 0);
  }
}
